import React, { FunctionComponent, useRef, useEffect } from "react";
import { useState } from "react";
import Loading from "../../Components/Loading/Loading";
import styles from "../AddContacts/AddContacts.module.css";
import { AiOutlineClose } from "react-icons/ai";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import { createLicensesCost, fetchLicensesCost } from "../../Services/resources";
import Label from "../../Components/Label";
import { themeColors } from "../../Components/theme";
import { Grid, Button, useMediaQuery, useTheme, Box } from "@mui/material";
import TextInput from '../../Components/TextInput/InputText';
import StyledSubmitButton from "../../Components/Buttons/StyledSubmitButton";
import { Circles } from "react-loader-spinner";
import "../../theme-vars.css";

type props = {
    history: any;
    user: any;
    theme: any;
};
const AddLicensesCost: FunctionComponent<props> = ({ history, user, theme }) => {
    const themeMUI = useTheme();
    const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
    const [load, setLoad] = useState(false);
    const [sNumber, setSNumber] = useState<any>("");
    const [tPNumber, setTPNumber] = useState<any>("");
    const [cost, setCost] = useState<any[] | undefined>(undefined);
    const dispatcher = useDispatch();
    const srNumberRef: any = useRef();
    const tpNumberRef: any = useRef();


    useEffect(() => {
        fetchLicensesCost((data) => setCost(data), (data) => setLoad(data));
    }, [])

    useEffect(() => {
        setSNumber(cost?.[0]?.licensesCost);
        setTPNumber(cost?.[0]?.no_employees);
    }, [cost])

    const handleCheck = () => {
        if (srNumberRef.current.value === "") {
            dispatcher(showSnackbarAction("Please Enter Licenses Cost !!", "error"));
            return false;
        }
        if (tpNumberRef.current.value === "") {
            dispatcher(showSnackbarAction("Please Enter Number of licenses (trial period)  !!", "error"));
            return false;
        }
        else {
            return true;
        }
    };
    const create = (e: any) => {
        e.preventDefault();
        const val = handleCheck();
        if (val) {
            setLoad(true);
            createLicensesCost(
                srNumberRef.current.value,
                tpNumberRef.current.value,
                dispatcher,
                (data: boolean) => setLoad(data),
                history
            );
        }
    };
    const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
    const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
    return (
        <div className={styles.parent} style={{ ...containerStyles, marginTop: isMobile ? "6%" : "4%", fontFamily: "var(--font-family-main)" }}>
            {load && <Loading />}
            {isMobile && (
                <div className="d-flex flex-row w-100 px-4 pt-2">
                    <h5 style={{ fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-large)" }}>Licenses Cost</h5>
                </div>
            )}
            <div
                className="w-100 d-flex flex-column gap-2 px-4"
                style={{
                    padding: isMobile ? '0' : '',
                    maxWidth: isMobile ? '100vw' : undefined,
                    margin: isMobile ? '0' : '0 auto',
                    overflowY: isMobile ? 'auto' : undefined,
                    maxHeight: isMobile ? 'calc(100vh - 120px)' : undefined,
                }}
            >
                <form
                    className={`card shadow rounded mt-2${!isMobile ? ` ${styles.forcePadding}` : ""}`}
                    style={{
                        ...cardContainerStyles,
                        padding: isMobile ? '16px' : '32px',
                        boxSizing: 'border-box',
                        minHeight: isMobile ? 'auto' : undefined,
                        marginBottom: isMobile ? '50px' : 0,
                    }}
                // onSubmit={create}
                >
                    <Grid container spacing={isMobile ? 2 : 3}>
                        <Grid item xs={12} sm={6}>
                            <TextInput
                                title="Licenses Cost"
                                style={{ backgroundColor: "#fff", width: '100%' }}
                                ref={srNumberRef}
                                required={true}
                                value={sNumber}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextInput
                                title="Number of Licenses(trial period)"
                                style={{ backgroundColor: "#fff", width: '100%' }}
                                ref={tpNumberRef}
                                required={true}
                                value={tPNumber}
                            />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 12 }}>
                            <StyledSubmitButton
                                onClick={(e) => create(e)}
                                themeMode={themeMUI.palette.mode}
                            >
                                {load ? (
                                    <span style={{ display: "flex", justifyContent: "center" }}>
                                        <Circles color="#fff" height={20} width={20} />
                                    </span>
                                ) : (
                                    <>Submit</>
                                )}
                            </StyledSubmitButton>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        theme: state.theme.isLightMode
    };
};

export default connect(mapStateToProps)(AddLicensesCost);